import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlPmsIntegrationsGetInformationRequest } from "../models/service-models/pmsIntegrations/PmsIntegrationsGetInformationRequest";
import { mdlPmsIntegrationsGetInformationResponse } from "../models/service-models/pmsIntegrations/PmsIntegrationsGetInformationResponse";
import { mdlPmsIntegrationsListRequest } from "../models/service-models/pmsIntegrations/PmsIntegrationsListRequest";
import { mdlPmsIntegrationsListResponse } from "../models/service-models/pmsIntegrations/PmsIntegrationsListResponse";
import { GetResponse } from "../utils/ApiClient";

module PmsIntegrationsService {
    export async function List(
        pRequest: mdlPmsIntegrationsListRequest
    ): Promise<mdlServiceResponse<mdlPmsIntegrationsListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlPmsIntegrationsListResponse>>(
            "pmsIntegration/list",
            pRequest
        );
    }

    export async function CreateInformationRequest(
        pRequest: mdlPmsIntegrationsGetInformationRequest
    ): Promise<mdlServiceResponse<mdlPmsIntegrationsGetInformationResponse>> {
        return await GetResponse<mdlServiceResponse<mdlPmsIntegrationsGetInformationResponse>>(
            "pmsIntegration/create-information-request",
            pRequest
        );
    }
}

export { PmsIntegrationsService }